import { render, staticRenderFns } from "./SafetyAccidentReview.vue?vue&type=template&id=707dec3b&scoped=true&"
import script from "./SafetyAccidentReview.vue?vue&type=script&lang=js&"
export * from "./SafetyAccidentReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707dec3b",
  null
  
)

export default component.exports